import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants/primitives';

export const sharedStyles = StyleSheet.create({
  bodyText: {
    fontSize: primitive.fontSizes.md,
    fontFamily: primitive.fontFamily.$body,
    textAlign: 'center',
  },
});
